import { createBootstrap } from "byzantine";

// eslint-disable-next-line import/prefer-default-export
export const Bootstrap = createBootstrap("institution");
